import { Injectable, NgModule, Injector } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpResponse } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { map, takeUntil, take } from 'rxjs/operators';
import { Router } from '@angular/router';

const skipList = ['paymentFromMPago', 'setDocumentProfile', 'paymentFromWebpay', 'consultPaymentWebpay', 'payment/confirm'];

@Injectable()
export class HttpsRequestInterceptor implements HttpInterceptor {
    router: any;

    stopSignal$ = new Subject<void>();
    /**
     * @type {{headers: HttpHeaders}}
     */
    public httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'Cache-Control:no-cache',
        }),
    };

    constructor(private injector: Injector) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        /**
         * Injeta manualmente o módulo Router, ao invés de por no constructor
         * Necessário para resolver problema de cyclic dependecy
         * @see https://stackoverflow.com/questions/47449520/cannot-instantiate-cyclic-dependency-httpclient-error-in-ngmodule-app
         */
        this.router = this.injector.get(Router);

        const httpOptions = skipList.some((endpoint) => req.url.includes(endpoint)) ? {} : this.httpOptions;
        /* Duplica requisição com novas configurações */
        let dupReq = req.clone(httpOptions);

        return next.handle(dupReq).pipe(
            map((event) => {
                const isHttpResponseEvent = this.mapHttpResponseEvent(event);
                if (isHttpResponseEvent) {
                    if (req.url.includes('privacy')) return event;
                    this.handleStatusCode(event as HttpResponse<any>);
                }

                return event;
            }),
            takeUntil(this.stopSignal$)
        );
    }

    mapHttpResponseEvent(event: HttpEvent<any>) {
        return event instanceof HttpResponse;
    }

    /**
     * Se status_code receber os valores:
     * [8] - Token para revalidação de email/senha, expirou.
     * [9] - Token inexistente ou data de validade inválida.
     *
     * @param response
     */
    handleStatusCode(response: HttpResponse<any>) {
        if (response.body.status_code == 8) {
            /* Cancela próximas requisições */
            this.stopSignal$.next();
            this.stopSignal$.complete();

            setTimeout(() => {
                this.router.navigate(['/acesso-revalidar-negado']);
            }, 0);
        } else if (response.body.status_code == 9) {
            /* Cancela próximas requisições */
            this.stopSignal$.next();
            this.stopSignal$.complete();

            setTimeout(() => {
                this.router.navigate(['/acesso-negado']);
            }, 0);
        }
        return response;
    }
}

@NgModule({
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpsRequestInterceptor,
            multi: true,
        },
    ],
})
export class Interceptor {}
